import React from 'react';
import {Fieldset} from 'components/customer/Product/entity/Fieldset';
import {InnerDrawerHardwareDefaults} from 'components/customer/Product/Specs/InnerDrawerHardwareDefaults';
import {
    Card,
    CardHeader,
} from 'components/customer/Product/Drawer/layoutStyles';

interface InnerDrawerHardwareProps {
    // the inner drawer_runners fieldset, which carries the type and runner names
    runnerFieldset: Fieldset;
}

export const InnerDrawerHardware = ({
    runnerFieldset,
}: InnerDrawerHardwareProps) => {
    const field = runnerFieldset?.fields?.[0];

    if (!field) return null;

    return (
        <Card data-cy="inner-drawer-hardware-card">
            <CardHeader>Inner Drawer Hardware</CardHeader>
            <InnerDrawerHardwareDefaults
                field={field}
                fieldset={runnerFieldset}
            />
        </Card>
    );
};
